<p-toast></p-toast>
<router-outlet></router-outlet>
<app-spinner></app-spinner>